import React from 'react'
import { useLanguage } from '../../Providers/LanguageContext'
import SignUpButton from './SignUpButton';
import { IoMdAdd } from 'react-icons/io';
import iMg1 from "../../images/ilustraciones soluciones industriales_AGRICULTURA 1 .png";
import iMg2 from "../../images/ilustraciones soluciones industriales_AGRICULTURA 2 EN.png";
import iMg3 from "../../images/ilustraciones soluciones industriales_AGRICULTURA 3 .png";
import iMg3en from "../../images/ilustraciones soluciones industriales_AGRICULTURA 3 EN.png";
import { useNavigate } from 'react-router-dom';
import AgricultureBanner from './AgricultureBanner';

function Agriculture() {
    const { language, currentLanguage } = useLanguage();
    const navigate = useNavigate();
    // console.log('language', language)
    return (
        <>
            <AgricultureBanner agriculture={true} />

            <section id='agriculture_sec' style={{
                background:'#0c2637',
                padding:'0px 0px 30px 0px'
            }}>
                <div className='container-fluid  d-block'>
                    <div className='row mb-5'>
                        <div style={{
                            background: '#fff'
                        }} className='col-md-6 col-12 m-auto agriculture_box'>
                            {/* <div className='agriculture_head'>
                                <h3 style={{ color: "#2c7300", }}>{language.agriculture}</h3>
                            </div> */}

                            <div className='agriculture_headtext'>
                                <h4 style={{ color: "#000", fontWeight: '700', fontSize: '42px' }}>{language.cop_liverstock}</h4>
                                <p style={{
                                    color: '#025505',
                                    fontWeight: '600',
                                    fontSize: '20px'
                                }}>{language.fisibility_allows_farmars}</p>
                                <ul>
                                    <li style={{
                                        color: '#0c2637'
                                    }}>{language.crops}</li>
                                    <li style={{
                                        color: '#0c2637'
                                    }}>{language.expenses}</li>
                                    <li style={{
                                        color: '#0c2637'
                                    }}>{language.cattle_health}</li>
                                </ul>
                                <p style={{
                                    color: '#0c2637',
                                    fontWeight: '600',
                                    fontSize: '25px',
                                    letterSpacing: 'auto'
                                }} >{language.giving_them_real_time}</p>
                            </div>
                        </div>
                        <div className='col-md-5 col-12 m-auto'>
                            <div className='agriculture_img'>
                                <img src={iMg1} className='img-fluid' alt='' />
                            </div>
                        </div>
                    </div>

                    <div className='row mb-5 row_reverse'>
                        <div className='col-md-5 col-12 m-auto'>
                            <div className='agriculture_img'>
                                <img src={iMg2} className='img-fluid' alt='' />
                            </div>
                        </div>

                        <div style={{
                            background: '#fff'
                        }} className='col-md-6 col-12 m-auto agriculture_box'>
                            <div className='agriculture_headtext'>
                                <h4 style={{ color: "#000", fontWeight: '700', fontSize: '38px', textAlign: 'right' }}>{language.invest_management}</h4>
                                <p style={{
                                    color: '#0c2637',
                                    fontWeight: '600',
                                    fontSize: '18px',
                                    textAlign: 'right'
                                }}>{language.with_fisi_farmers}</p>
                            </div>

                            <div className='agriculture_headtext'>
                                <h4 style={{ color: "#000", fontWeight: '700', fontSize: '38px', textAlign: 'left' }}>{language.financial_planning}</h4>
                                <p style={{
                                    color: '#000',
                                    fontSize: '18px'
                                }}> {language.fisi_help_farmers}</p>
                            </div>
                        </div>
                    </div>

                    <div className='row mb-5'>
                        <div style={{
                            background: '#fff'
                        }} className='col-md-6 col-12 agriculture_box'>
                            <div className='agriculture_headtext'>
                                <h4 style={{ color: "#000", fontWeight: '700', fontSize: '38px' }}>{language.compliance_management}</h4>
                                <p style={{
                                    color: '#000',
                                    fontSize: '20px'
                                }}>{language.fisi_farmer_compliant}</p>
                            </div>

                            <div className='agriculture_headtext'>
                                <h4 style={{ color: "#000", fontWeight: '700', fontSize: '38px' }}>{language.supply_chain_management}</h4>
                                <p style={{
                                    color: '#000',
                                    fontSize: '20px'
                                }}>{language.fisi_farmers_manage}</p>
                            </div>
                        </div>


                        <div className='col-md-5 col-12 m-auto'>
                            <div className='agriculture_img'>
                                {
                                    currentLanguage === 'spanish'
                                        ?
                                        <img src={iMg3} className='img-fluid' alt='' />
                                        :
                                        <img src={iMg3en} className='img-fluid' alt='' />
                                }

                                <div className='registrarAnddescargar'>
                                    {/* <button className='registrar_Btn' onClick={() => navigate('/login')}>Registrarse</button>
                                    <button className='descargar_Btn'>Descargar</button> */}
                                    <SignUpButton />
                                </div>
                            </div>
                        </div>
                    </div>






                </div>
            </section>
        </>
    )
}

export default Agriculture